export const setMultiLineDirective = ['$timeout', ($timeout) => {
    return {
        restrict: 'A',
        link: function (scope, element) {
            $timeout(function () {
                var parentContainer = element.parent()[0];
                // Padding of ui-grid-cell-contents is 5px.
                // TODO: Better way to get padding height?
                var topBottomPadding = 10;
                var rowHeight = topBottomPadding + parentContainer.offsetHeight;
                var gridRowHeight = scope.grid.options.rowHeight;
                if (!gridRowHeight || gridRowHeight && gridRowHeight < rowHeight) {
                    // This will OVERRIDE the existing rowHeight.
                    scope.grid.options.rowHeight = rowHeight;
                }
            }, 0);
        }
    }
}];



// WEBPACK FOOTER //
// ./src/app/common/directives/setMultiLine.js